import { PaymentRequestPaymentMethodEvent } from '@stripe/stripe-js'
import { PageId } from 'constants/pages'
import { ILeadPlanRaw } from 'models/lead.model'
import { PaymentSystem } from 'nove8/constants/root-constants'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface IGlobalLocalStore {
  purchaseId: string
  purchasePageId: PageId | null // needed to redirect user to the correct page in case reload during the purchase polling
  paymentSystem: PaymentSystem | null
  lastUsedPaymentMethod: string // method the subscription is billed with, kept between purchases so upsells report the method they charge
  createPaymentResFromDigitalWallet: PaymentRequestPaymentMethodEvent | null // don't use this to get lastUsedPaymentMethod, use lastUsedPaymentMethod instead
  hasPurchaseSuccessfullyCompleted: boolean
  selectedLeadPlan: ILeadPlanRaw | null
  isStoppedPolling: boolean
  planNumber: string // client generated plan number for decoration purposes
  abSegmentName: string
  sprtAnswer: string
  customToken: string // used in old subscriptions as well // firebase custom token taken from BE
  previousCohort: string // used only for detecting cohort changing
  previousLeadId: string // used only for detecting lead id changing
}

const INITIAL_STORE: IGlobalLocalStore = {
  purchaseId: '',
  purchasePageId: null,
  paymentSystem: null,
  lastUsedPaymentMethod: '',
  createPaymentResFromDigitalWallet: null,
  hasPurchaseSuccessfullyCompleted: false,
  selectedLeadPlan: null,
  isStoppedPolling: false,
  abSegmentName: '',
  sprtAnswer: '',
  customToken: '',
  planNumber: '',
  previousCohort: '',
  previousLeadId: '',
}

export const useZustandGlobalLocalStore = create<IGlobalLocalStore>()(
  persist(() => INITIAL_STORE, {
    name: 'data-storage', // name of the item in the storage (must be unique)
    version: 1,
    migrate: (persistedState, version) => {
      const state = persistedState as IGlobalLocalStore & {
        paymentMethod?: string
      }

      if (version < 1) {
        const { paymentMethod, ...rest } = state

        return {
          ...rest,
          lastUsedPaymentMethod:
            rest.lastUsedPaymentMethod || paymentMethod || '',
        }
      }

      return state
    },
  }),
)
export const useZustandLocalStore = useZustandGlobalLocalStore
